;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .controller('IntegrationCtrl', IntegrationCtrl)

  function IntegrationCtrl(
    $scope,
    $location,
    $filter,
    $routeSegment,
    integrationService,
    ErrorService,
    UserService,
    WebhookFactory,
    BugtrackerFactory,
    JobOutcomePolicyFactory,
    INTEGRATION_TYPE
  ) {
    'ngInject'

    angular.extend($scope, {
      integrations: {
        bugtrackers: {
          jira: [],
          vsts: [],
          github: [],
          agileCentral: []
        },
        webhooks: {
          slack: [],
          victorops: [],
          pagerduty: [],
          generic: [],
          microsoftteams: []
        },
        jobOutcomePolicy: {
          jenkins: []
        }
      },
      collapseData: {
        collapsing: {
          jira: false,
          vsts: false,
          github: false,
          agileCentral: false,
          slack: false,
          victorops: false,
          pagerduty: false,
          generic: false,
          microsoftteams: false,
          jenkins: false
        },
        collapsed: {
          jira: false,
          vsts: false,
          github: false,
          agileCentral: false,
          slack: false,
          victorops: false,
          pagerduty: false,
          generic: false,
          microsoftteams: false,
          jenkins: false
        }
      },
      show: {
        jira: false,
        vsts: false,
        github: false,
        agileCentral: false,
        generic: false,
        victorops: false,
        pagerduty: false,
        slack: false,
        microsoftteams: false,
        jenkins: false
      },
      webhooksPromise: undefined,
      bugtrackersPromise: undefined,
      jobOutcomePolicyPromise: undefined,
      apps_limit: 5,
      importance_limit: 5,
      severity_limit: 5
    })

    angular.extend($scope, {
      clearWebhooks: clearWebhooks,
      deleteIntegration: deleteIntegration,
      deleteBugtrackerIntegration: deleteBugtrackerIntegration,
      deleteJobOutcomePolicy: deleteJobOutcomePolicy,
      manageWebhook: manageWebhook,
      setCollapsing: setCollapsing,
      setCollapsed: setCollapsed,
      showAllApps: showAllApps,
      getOverviewUrl: getOverviewUrl
    })

    var orgUuid

    function getOverviewUrl(integration) {
      switch (integration.keycode) {
        case INTEGRATION_TYPE.JIRA:
          return $routeSegment.getSegmentUrl('settings.jira_edit', {
            orgUuid: orgUuid,
            jiraId: integration.bugtracker_id
          })
        case INTEGRATION_TYPE.VSTS:
          return $routeSegment.getSegmentUrl('settings.vsts_edit', {
            orgUuid: orgUuid,
            vstsId: integration.bugtracker_id
          })
        case INTEGRATION_TYPE.GITHUB:
          return $routeSegment.getSegmentUrl('settings.github_edit', {
            orgUuid: orgUuid,
            githubId: integration.bugtracker_id
          })
        case INTEGRATION_TYPE.AGILE_CENTRAL:
          return $routeSegment.getSegmentUrl('settings.agile_central_edit', {
            orgUuid: orgUuid,
            agileCentralId: integration.bugtracker_id
          })
        case INTEGRATION_TYPE.JENKINS:
          return $routeSegment.getSegmentUrl('settings.jenkins_edit', {
            orgUuid: orgUuid,
            jenkinsId: integration.policy_id
          })

        default:
          break
      }
    }

    function _showUnavailableConnections(integrations) {
      var showUnavailableConnections = false
      _.each(integrations, function (integration) {
        if (!showUnavailableConnections && integration.connection_unavailable) {
          showUnavailableConnections = true
        }
      })
      return showUnavailableConnections
    }

    function showAllApps(integration) {
      integration.appsLimit = 'Infinity'
    }

    function init() {
      orgUuid = UserService.getCurrentOrganizationId()
      $scope.webhooksPromise = loadWebhooks()
      $scope.bugtrackersPromise = loadBugtrackers()
      $scope.jobOutcomePolicyPromise = loadJobOutcomePolicy()
    }

    function setCollapsing(name) {
      $scope.collapseData.collapsing[name] = true
      $scope.collapseData.collapsed[name] = false
    }

    function setCollapsed(name) {
      $scope.collapseData.collapsed[name] = true
      $scope.collapseData.collapsing[name] = false
    }

    function clearWebhooks() {
      for (var key in $scope.integrations.webhooks) {
        if ($scope.integrations.webhooks.hasOwnProperty(key)) {
          $scope.integrations.webhooks[key] = []
        }
      }
    }

    function clearBugtrackers() {
      for (var key in $scope.integrations.bugtrackers) {
        if ($scope.integrations.bugtrackers.hasOwnProperty(key)) {
          $scope.integrations.bugtrackers[key] = []
        }
      }
    }
    function clearJobOutcomePolicy() {
      for (var key in $scope.integrations.jobOutcomePolicy) {
        if ($scope.integrations.jobOutcomePolicy.hasOwnProperty(key)) {
          $scope.integrations.jobOutcomePolicy[key] = []
        }
      }
    }

    function deleteIntegration(webhook) {
      integrationService.deleteIntegration(webhook).then(function () {
        loadWebhooks()
      })
    }

    function deleteBugtrackerIntegration(bugtracker, type, id, addWarning) {
      integrationService
        .deleteIntegration(bugtracker, type, id, addWarning)
        .then(function () {
          loadBugtrackers()
        })
    }

    function deleteJobOutcomePolicy(jobOutcomePolicy, type, id, addWarning) {
      integrationService
        .deleteIntegration(
          jobOutcomePolicy,
          INTEGRATION_TYPE.JENKINS,
          id,
          addWarning
        )
        .then(function () {
          loadJobOutcomePolicy()
        })
    }

    function loadWebhooks() {
      return WebhookFactory.getWebhooks().then(
        function (response) {
          clearWebhooks()

          $scope.integrations.webhooks.slack = $filter('filter')(
            response.data.webhooks,
            { webhook_type: INTEGRATION_TYPE.SLACK }
          )
          $scope.integrations.webhooks.victorops = $filter('filter')(
            response.data.webhooks,
            { webhook_type: INTEGRATION_TYPE.VICTOROPS }
          )
          $scope.integrations.webhooks.pagerduty = $filter('filter')(
            response.data.webhooks,
            { webhook_type: INTEGRATION_TYPE.PAGERDUTY }
          )
          $scope.integrations.webhooks.generic = $filter('filter')(
            response.data.webhooks,
            { webhook_type: INTEGRATION_TYPE.GENERIC }
          )
          $scope.integrations.webhooks.microsoftteams = $filter('filter')(
            response.data.webhooks,
            { webhook_type: INTEGRATION_TYPE.MICROSOFTTEAMS }
          )
          _addAppsLimit($scope.integrations.webhooks.slack)
          _addAppsLimit($scope.integrations.webhooks.pagerduty)
          _addAppsLimit($scope.integrations.webhooks.victorops)
          _addAppsLimit($scope.integrations.webhooks.generic)
          _addAppsLimit($scope.integrations.webhooks.microsoftteams)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadBugtrackers() {
      return BugtrackerFactory.getBugtrackers().then(
        function (response) {
          clearBugtrackers()
          $scope.integrations.bugtrackers.jira = $filter('filter')(
            response.data.bugtrackers,
            { keycode: INTEGRATION_TYPE.JIRA }
          )
          $scope.integrations.bugtrackers.vsts = $filter('filter')(
            response.data.bugtrackers,
            { keycode: INTEGRATION_TYPE.VSTS }
          )
          $scope.integrations.bugtrackers.github = $filter('filter')(
            response.data.bugtrackers,
            { keycode: INTEGRATION_TYPE.GITHUB }
          )
          $scope.integrations.bugtrackers.agileCentral = $filter('filter')(
            response.data.bugtrackers,
            { keycode: INTEGRATION_TYPE.AGILE_CENTRAL }
          )

          _addAppsLimit($scope.integrations.bugtrackers.jira)
          _addAppImportanceLimit($scope.integrations.bugtrackers.jira)
          _addAppsLimit($scope.integrations.bugtrackers.vsts)
          _addAppsLimit($scope.integrations.bugtrackers.github)
          _addAppsLimit($scope.integrations.bugtrackers.agileCentral)

          $scope.show.jira = _showUnavailableConnections(
            $scope.integrations.bugtrackers.jira
          )
          $scope.show.vsts = _showUnavailableConnections(
            $scope.integrations.bugtrackers.vsts
          )
          $scope.show.github = _showUnavailableConnections(
            $scope.integrations.bugtrackers.github
          )
          $scope.show.agileCentral = _showUnavailableConnections(
            $scope.integrations.bugtrackers.agileCentral
          )
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadJobOutcomePolicy() {
      return JobOutcomePolicyFactory.getJobOutcomePolicy().then(
        function (response) {
          clearJobOutcomePolicy()
          $scope.integrations.jobOutcomePolicy.jenkins = $filter('filter')(
            response.data.policies
          )

          _addAppsLimit($scope.integrations.jobOutcomePolicy.jenkins)
          _addAppImportanceLimit($scope.integrations.jobOutcomePolicy.jenkins)

          $scope.show.jenkins = _showUnavailableConnections(
            $scope.integrations.jobOutcomePolicy.jenkins
          )
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _addAppsLimit(integrations) {
      _.each(integrations, function (integration) {
        _.extend(integration, { appsLimit: 5 })
      })
    }

    function _addAppImportanceLimit(integrations) {
      _.each(integrations, function (integration) {
        _.extend(integration, { appImportanceLimit: 5 })
      })
    }

    function manageWebhook(webhookId) {
      $location.path(
        UserService.buildUrl('/settings/notifications/' + webhookId)
      )
    }

    init()
  }
})()
